import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Trash2, Truck } from "lucide-react";

export const vehicleLabel = (v) => (v.plate ? `${v.name} · ${v.plate}` : v.name);

const VehicleFields = ({ form, setForm, testPrefix }) => (
  <div className="flex w-full gap-2 sm:w-auto sm:flex-1">
    <Input data-testid={`${testPrefix}-name`} value={form.name} placeholder="Mezzo (es. Iveco Daily)" onChange={(e) => setForm({ ...form, name: e.target.value })} className="h-10 min-w-0 flex-1 rounded-lg bg-white" />
    <Input data-testid={`${testPrefix}-plate`} value={form.plate} placeholder="Targa" onChange={(e) => setForm({ ...form, plate: e.target.value })} className="h-10 w-28 shrink-0 rounded-lg bg-white uppercase" />
  </div>
);

const VehicleRow = ({ vehicle, onUpdate, onDelete }) => {
  const [form, setForm] = useState(vehicle);
  const [confirm, setConfirm] = useState(false);
  useEffect(() => {
    setForm(vehicle);
  }, [vehicle]);
  const dirty = form.name !== vehicle.name || form.plate !== vehicle.plate;

  return (
    <div data-testid={`vehicle-row-${vehicle.id}`} className="flex flex-wrap items-center gap-2 rounded-xl border bg-slate-50 p-3">
      <Truck className="hidden h-4 w-4 shrink-0 text-slate-400 sm:block" />
      <VehicleFields form={form} setForm={setForm} testPrefix={`vehicle-${vehicle.id}`} />
      <div className="ml-auto flex gap-1">
        <Button data-testid={`vehicle-delete-${vehicle.id}`} variant="ghost" size="sm" className="text-rose-600 hover:bg-rose-50" onClick={() => (confirm ? onDelete(vehicle.id) : setConfirm(true))}>
          <Trash2 className="h-4 w-4" /> {confirm && "Conferma"}
        </Button>
        <Button data-testid={`vehicle-save-${vehicle.id}`} size="sm" disabled={!dirty || !form.name.trim()} onClick={() => onUpdate(vehicle.id, form)}>Salva</Button>
      </div>
    </div>
  );
};

const NewVehicle = ({ onCreate }) => {
  const [form, setForm] = useState({ name: "", plate: "" });
  const submit = async (e) => {
    e.preventDefault();
    if (form.name.trim() && (await onCreate(form))) setForm({ name: "", plate: "" });
  };
  return (
    <form onSubmit={submit} className="flex flex-wrap items-center gap-2 rounded-xl border border-dashed p-3">
      <VehicleFields form={form} setForm={setForm} testPrefix="new-vehicle" />
      <Button data-testid="new-vehicle-add-btn" type="submit" size="sm" disabled={!form.name.trim()} className="ml-auto gap-1">
        <Plus className="h-4 w-4" /> Aggiungi
      </Button>
    </form>
  );
};

export const VehiclesDialog = ({ open, onOpenChange, vehicles, onCreate, onUpdate, onDelete }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="vehicles-dialog" className="max-h-[92vh] overflow-y-auto rounded-2xl sm:max-w-xl">
      <DialogHeader>
        <DialogTitle className="font-display">Automezzi</DialogTitle>
        <DialogDescription>I mezzi inseriti qui si scelgono al volo nelle attività.</DialogDescription>
      </DialogHeader>
      <div className="space-y-2">
        {vehicles.map((v) => (
          <VehicleRow key={v.id} vehicle={v} onUpdate={onUpdate} onDelete={onDelete} />
        ))}
        {vehicles.length === 0 && <p data-testid="vehicles-empty" className="py-2 text-sm text-slate-500">Nessun automezzo ancora inserito.</p>}
        <NewVehicle onCreate={onCreate} />
      </div>
    </DialogContent>
  </Dialog>
);
